import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, switchMap, from, map, Observable, firstValueFrom } from 'rxjs';
import { SystemMessageService } from './system-message.service';
import { environment } from '../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { Servers } from '../constants/servers';

export interface maintenanceMessageList {
  message_key: string,
  message_fr: string,
  message_en: string
}

export interface serversInfo{
  name: string,
  maint_mode: number
}

@Injectable({
  providedIn: 'root'
})
export class ManageService {
  // **** App varaibles **** //
  // Variable used to show/hide modal
  public showManageModal: boolean = false;
  public isUpdateMaintenanceMessageActive: boolean = false;
  public isSetupMaintenanceMessageActive: boolean = false;
  public isCreateMaintenanceMessageActive: boolean = false;
  public isUserRoleActive: boolean = false;

  // Variable used in manage modal to display message
  public messageKey: string = '';
  public messageId: string = '';
  public messageValue: string | undefined = '';

  // Variable used to check if there's a date or time to implemente
  public isDate1ToImplement: boolean = false;
  public isTime1ToImplement: boolean = false;
  public isDate2ToImplement: boolean = false;
  public isTime2ToImplement: boolean = false;
  public isPicker1Active: boolean = false;
  public isPicker2Active: boolean = false;

  // Variable used for the user selected date and time
  public selectedDate1: Date = new Date();
  public selectedTime1: string = new Date().toTimeString().slice(0, 5);
  public selectedDate2: Date = new Date();
  public selectedTime2: string = new Date().toTimeString().slice(0, 5);

  // Variables used for validations
  private isSaveValid: boolean = false;

  // Variables used to trigger function in other component
  private maintenanceMessageSaved = new Subject<void>;
  maintenanceMessageSaved$ = this.maintenanceMessageSaved.asObservable();
  private maintenanceMessageCreated = new Subject<void>;
  maintenanceMessageCreated$ = this.maintenanceMessageCreated.asObservable();

  // For textarea in modal
  public frenchTextarea: string = '';
  public englishTextarea: string = '';

  // Varaibles used in select
  public selectedServers: string[] = [];
  public servers = Servers;
  public alertTypes: string | null = null;

  // Variables used in role modal
  public currentUserRoles: any[] = [];
  public selectedUserRoles: any[] = [];
  public selectedUserId: string = '';

  // Variables used for servers infos
  public serversInfoList: serversInfo[] = [];

  // Others
  public userId?: string = ''; // Current userid
  public keepAfterDelay: boolean = false;
  public activeMaintenanceMessage: any = {};
  public activeMaintenanceMessageArray: any;

  public maintenanceMessageList: maintenanceMessageList[] = [];


  public testBenVar: any;

  constructor(
    private http: HttpClient,
    private systemMessageService: SystemMessageService
  ) { }

  // Function called when user open the maintenance message modal, this funciton will be called every time the modal is opened
  async openMaintenanceMessageModal(key: string, message_id: string = '', alert_type: string = '', message: string = '', date_time_from: number = 0, date_time_to: number = 0, servers: string[] = []){
    // Set the UI variable at true to open the modal
    this.showManageModal = true;

    this.messageKey = key;
    if(message !== ''){
      this.messageValue = message;
    }else{
      this.messageValue = this.maintenanceMessageList.find(item => item.message_key === key)?.message_fr;
    }


    // In case that user try to update a maintenance message
    // Set the messageId and will set the message value with the replaced version of %DATEFROM% etc....
    if(message_id){
      this.messageId = message_id;

      // Get the two date and time if there's is some
      this.selectedDate1 = new Date(date_time_from * 1000);
      this.selectedTime1 = this.formatTimestampToDateAndTime(date_time_from).time;
      this.selectedDate2 = new Date(date_time_to * 1000);
      this.selectedTime2 = this.formatTimestampToDateAndTime(date_time_to).time;

      // Get the servers where the message should be showed and the alert type
      this.selectedServers = servers;
      this.alertTypes = alert_type;
    }
    let messageTemplate: any;

    // If the message list is empty call the function to repopulate it
    if(this.maintenanceMessageList.length <= 0){
      await this.getMaintenanceMessageList();
    }
    // Set the message template to the proper one from the list
    messageTemplate = this.maintenanceMessageList.find(item => item.message_key === key);

    if(messageTemplate){
      // Check if the french string contain a Date or Time
      this.isDate1ToImplement = messageTemplate.message_fr.includes('%DATEFROM%');
      this.isTime1ToImplement = messageTemplate.message_fr.includes('%TIMEFROM%');
      this.isDate2ToImplement = messageTemplate.message_fr.includes('%DATETO%');
      this.isTime2ToImplement = messageTemplate.message_fr.includes('%TIMETO%');
    }

    // Set the boolean variables to show/hide the block of date-picker or time-picker
    if(this.isDate1ToImplement || this.isTime1ToImplement){
      this.isPicker1Active = true;
    }
    if(this.isDate2ToImplement || this.isTime2ToImplement){
      this.isPicker2Active = true;
    }
  }

  // Function used to get the maintenance message list
  async getMaintenanceMessageList(){
    await this.getDBMaintenanceMessageList().then((response: any) => {
      this.maintenanceMessageList = response.data.map((item: any) => ({
        ...item,
        message_fr: this.decodeHtml(item.message_fr),
        message_en: this.decodeHtml(item.message_en)
      }));
    });
  }

  // Function used when user save something and get a response from the API. Thke this response and close the modal if response is successfull
  checkResponse(response: any){
    if(response === 'success'){
      // If response from API is successfull, set a ribbon for the user and close the modal
      this.systemMessageService.selectRibbon('success', 'loginFNewPasswordBtnConfirmNewPw');
      this.maintenanceMessageSaved.next();
      this.closeManageModal();
    }
  }

  // Function called to close the manage modal and set all bool variable to false, this function is called each time user close the modal
  closeManageModal(){
    // Set to false date/time show/hide cariable
    this.isDate1ToImplement = false;
    this.isTime1ToImplement = false;
    this.isDate2ToImplement = false;
    this.isTime2ToImplement = false;

    // Set to false show/hide variable for picker box
    this.isPicker1Active = false;
    this.isPicker2Active = false;

    // Set different <section> for the modal at false
    this.isSetupMaintenanceMessageActive = false;
    this.isUpdateMaintenanceMessageActive = false;
    this.isCreateMaintenanceMessageActive = false;
    this.isUserRoleActive = false;

    // Clear all maintenance message creation variable at nothing
    this.frenchTextarea = '';
    this.englishTextarea = '';
    this.messageKey = '';
    this.messageId = '';
    this.messageValue = '';
    this.selectedServers = [];
    this.alertTypes = null;
    this.keepAfterDelay = false;
    this.selectedDate1 = new Date();
    this.selectedTime1 = new Date().toTimeString().slice(0, 5);
    this.selectedDate2 = new Date();
    this.selectedTime2 = new Date().toTimeString().slice(0, 5);

    // Set validation variable at false
    this.isSaveValid = false;

    // Set to false show/hide modal variable to close it
    this.showManageModal = false;
  }

  // Function that handle each save button on the modal for the different modal set
  async saveButtonClicked(){
    switch(true){
      case this.isSetupMaintenanceMessageActive === true:
      case this.isUpdateMaintenanceMessageActive === true:
        await this.saveMaintenanceMessage();
        break;
      case this.isCreateMaintenanceMessageActive === true:
        this.createMaintenanceMessage();
        break;
      case this.isUserRoleActive === true:
        this.saveUserRoles();
        break;
    }
  }

  // Function used when user click the save button, check validations and call the saved function in DB
  async saveMaintenanceMessage(){
    // Check validations
    switch(true){
      // Conditions for saving
      case (this.selectedServers.length <= 0):
      case (this.alertTypes === '' || this.alertTypes === null):
      case (this.isDate1ToImplement && this.selectedDate1 === null):
      case (this.isDate2ToImplement && this.selectedDate2 === null):
      case (this.isTime1ToImplement && this.selectedTime1 === null):
      case (this.isTime2ToImplement && this.selectedTime2 === null):
      case (this.selectedDate1 === this.selectedDate2 && this.selectedTime1 === this.selectedTime2):
        // If all the pickers are set, put isSavedValid variable at true so user can save the maintenance message
        this.isSaveValid = false;
        this.systemMessageService.selectRibbon('danger', 'fieldEmptyOrIncorrect');
        break;

      // Set default to save variable at true
      default:
        this.isSaveValid = true;
        break;
    }

    if(this.isSaveValid){
      const utcTimestampDate1 = this.getUtcTimestampFromPicker(this.selectedDate1, this.selectedTime1);
      const utcTimestampDate2 = this.getUtcTimestampFromPicker(this.selectedDate2, this.selectedTime2);
      let response: any;

      // In the case that user want to set a new maintenance message
      if(this.messageId === ''){
        response = await firstValueFrom(this.saveDBSetupMaintenanceMessage(utcTimestampDate1, utcTimestampDate2));
      }

      // In the case that user want to update an existing maintenance message
      if(this.messageId !== ''){
        response = await firstValueFrom(this.updateDBMaintenanceMessage(utcTimestampDate1, utcTimestampDate2));
      }

      this.checkResponse(response);
    }
    // Reset validation variable to false for further use
    this.isSaveValid = false;
  }

  // Function used to save user roles
  async saveUserRoles(){
    const response = await firstValueFrom(this.saveDBUserRoles());
    this.checkResponse(response);
  }

  // Function used to create a new maintenance message
  async createMaintenanceMessage(){
    // Check all validations
    switch(true){
      case this.frenchTextarea === '':
      case this.englishTextarea === '':
      case this.messageKey === '':
      case this.messageKey.includes(' '):
        // Something wrong, set valid variable at false and show invalid message to the user
        this.isSaveValid = false;
        this.systemMessageService.selectRibbon('danger', 'fieldEmptyOrIncorrect');
        break;

      case await this.isMaintenanceMessageKeyExist():
        this.isSaveValid = false;
        this.systemMessageService.selectRibbon('danger', 'messageKeyAllreadyExist');
        break;
      // Set default to save variable at true
      default:
        this.isSaveValid = true;
        break;
    }
    let response: any;

    if(this.isSaveValid){
      response = await firstValueFrom(this.createDBMaintenanceMessage());
    }

    this.checkResponse(response);

    // Set saving variable at false just in case of
    this.isSaveValid = false;
  }

  // Function that call an other function used to see if maintenance message key allready exist
  async isMaintenanceMessageKeyExist(): Promise<boolean>{
    return await this.isDBMaintenanceMessageKeyExist().then((response: any) => {
      return response.data.length > 0;
    });
  }

  // Function that call the api to see if message key already exist
  isDBMaintenanceMessageKeyExist(): Promise<any>{
    // const maintenanceMessageKeyExist =
    return firstValueFrom(this.http.get(environment.api.cdn + environment.api.route.isMaintenanceMessageKeyExist + "?message_key=" + this.messageKey)
      .pipe(
        map((response: any) => {
          return JSON.parse(JSON.stringify(response));
        })
      ));
  }

  // Funciton that call api to get all the maintenance message models
  getDBMaintenanceMessageList(){
    return firstValueFrom(this.http.get(environment.api.cdn + environment.api.route.getMaintenanceMessageList)
      .pipe(
        map((response: any) => {
          return JSON.parse(JSON.stringify(response));
        })
      ));
  }

  // Function used when user want to put a maintenance message at inactive manually
  setInactiveMaintenanceMessage(){
    this.setInactiveDBMaintenanceMessage().subscribe((response) => {
      this.checkResponse(response);
    });
  }

  // Function that return a utc timestamp from a datepicker and a clockpicker
  getUtcTimestampFromPicker(dateStr: Date, timeStr: string){
    const date = new Date(dateStr);

    // Get the hour and minutes from the clockpicker then set the hour and minute for the utc timestamp
    const [hours, minutes] = timeStr.split(':').map(Number);
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);

    // Set the 13 number utc timestamp to a 10 number timestamp
    const utcTimestamp = Math.floor(date.getTime() / 1000);

    // Return the timestamp
    return utcTimestamp;
  }

  // Function that call the API to set tha changes in DB when we set a maintenance message
  saveDBSetupMaintenanceMessage(utcTimestampDate1: Number, utcTimestampDate2: Number){
    const headers = new HttpHeaders({
        'Content-Type':  'application/json' // Adjust content type as needed
    });
    return this.http.post(environment.api.cdn + environment.api.route.setMaintenanceMessage, {
      "message_key": this.messageKey,
      "alert_type": this.alertTypes,
      "timestampDate1": utcTimestampDate1,
      "timestampDate2": utcTimestampDate2,
      "userid": this.userId,
      "keep_after_delay": this.keepAfterDelay,
      "servers": this.selectedServers
    }, {headers: headers});
  }

  // Function that call the API to set the changes in DB when we update a maintenance message
  updateDBMaintenanceMessage(utcTimestampDate1: Number, utcTimestampDate2: Number){
    const headers = new HttpHeaders({
        'Content-Type':  'application/json' // Adjust content type as needed
    });
    return this.http.post(environment.api.cdn + environment.api.route.updateMaintenanceMessage, {
      "message_id": this.messageId,
      "alert_type": this.alertTypes,
      "timestampDate1": utcTimestampDate1,
      "timestampDate2": utcTimestampDate2,
      "keep_after_delay": this.keepAfterDelay,
      "servers": this.selectedServers
    }, {headers: headers});
  }

  // Function that call API to create a new maintenance message
  createDBMaintenanceMessage(){
    const headers = new HttpHeaders({
        'Content-Type':  'application/json' // Adjust content type as needed
    });
    return this.http.post(environment.api.cdn + environment.api.route.createNewMaintenanceMessage, {
      "message_key": this.messageKey,
      "message_fr": this.frenchTextarea,
      "message_en": this.englishTextarea
    }, {headers: headers});
  }

  // Functin that call the API to set the changes in DB when we put a maintenance message to inactive manually
  setInactiveDBMaintenanceMessage(){
    const headers = new HttpHeaders({
        'Content-Type':  'application/json' // Adjust content type as needed
    });
    return this.http.post(environment.api.cdn + environment.api.route.setInactiveMaintenanceMessage, {
      "message_id": this.messageId
    }, {headers: headers});
  }

  // Function used to save the selected user roles in the API
  saveDBUserRoles(){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(environment.api.cdn + environment.api.route.saveUserRoles, {
      "user_id": this.selectedUserId,
      "roles": this.selectedUserRoles
    }, {headers: headers});
  }

  // Function that return all the active maintenance message
  getActiveMaintenanceMessage(target: string = ''): Observable<any[]>{
    return this.http.get(environment.api.cdn + environment.api.route.getActiveMaintenanceMessage + '?target=' + encodeURIComponent(target)).pipe(
      switchMap((response) => {
        // Set a variable from the response that is json decoded
        this.activeMaintenanceMessage = JSON.parse(JSON.stringify(response));

        // Set a new varaible data to the data frm activeMaintenanceMessage
        const data = this.activeMaintenanceMessage.data;
        const promises = data.map(async (data: any) => {
          // Call the function to set at the proper format for the date and clock picker
          const { date: dateFrom, time: timeFrom } = this.formatTimestampToDateAndTime(data?.date_time_from);
          const { date: dateTo, time: timeTo } = this.formatTimestampToDateAndTime(data?.date_time_to);
          const parsedServers = JSON.parse(data.servers);

          // Take the message template from the .json french file, then replace all the date and time in the string to show to the user
          const message_fr = this.decodeHtml(data.french
            .replace('%DATEFROM%', dateFrom)
            .replace('%TIMEFROM%', timeFrom)
            .replace('%DATETO%', dateTo)
            .replace('%TIMETO%', timeTo));
          const message_en = this.decodeHtml(data.english
            .replace('%DATEFROM%', dateFrom)
            .replace('%TIMEFROM%', timeFrom)
            .replace('%DATETO%', dateTo)
            .replace('%TIMETO%', timeTo));

          // Return all message datas
          return {
            message_id: data.message_id,
            message_key: data.message_key,
            message_alert_type: data.alert_type,
            message_fr: message_fr,
            message_en: message_en,
            date_time_from: data.date_time_from,
            date_time_to: data.date_time_to,
            servers: parsedServers
          };
        });

        // Retunr to the component that use it an array of active maintenance message
        return from(Promise.all(promises));
      })
    );
  }

  // Function used to format the timestamp from DB to the proper setup for the date and clock picker
  formatTimestampToDateAndTime(timestamp: number | null): {date: string, time: string}{
    if(timestamp){
      const dateObj = new Date(timestamp * 1000);

      // Set all the data from the timestamp to format for the dae and clock picker
      const day = dateObj.getDate().toString().padStart(2, '0');
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const year = dateObj.getFullYear();
      const hours = dateObj.getHours().toString().padStart(2, '0');
      const minutes = dateObj.getMinutes().toString().padStart(2, '0');

      // Return the date and time for date and clock picker in the good format
      return {
        date: `${year}/${month}/${day}`,
        time: `${hours}:${minutes}`
      }
    }
    return {
      date: '',
      time: ''
    }
  }

  // Function used to create a new label for maintenace message
  openCreateMaintenanceMessage(){
    this.showManageModal = true;
    this.isCreateMaintenanceMessageActive = true;
  }

  // Function used to open user role modal
  async openUserRoleModal(userId: string){
    await this.getUserRoles(userId);
    this.showManageModal = true;
    this.isUserRoleActive = true;
    this.selectedUserId = userId;
  }

  // Function to get servers status
  getServersStatusInfo(): Observable<any>{
    // set params for get request
    const params = {
      "action": "getServersInfo"
    };

    // Get the response from get request and set it in response variable
    return this.http.get(environment.api.cdn + environment.api.route.getInManagePHP, { params });
  }

  // Function used to return available Servers in <select> tag
  getAvailableServers(){
    return this.servers.filter(server => !this.selectedServers.includes(server.value));
  }

  // Function used to decode special caracters in DB for UI display, ex: this &#039; to that '
  decodeHtml(html: string): string{
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  // Function used to set the maint-mode on servers
  async setServerInMaintMode(server: string, value: number){
    await firstValueFrom(this.setServerInMaintModeDB(server, value));

    this.serversInfoList = this.serversInfoList.map( s =>
      s.name === server ? { ...s, maint_mode: value } : s
    );
  }

  // Function used to set selected servers in maint mode
  setServerInMaintModeDB(server: string, value: number){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(environment.api.cdn + environment.api.route.setServerInMaintMode, {
      "server": server,
      "value": value
    }, {headers: headers});
  }

  // Function used to get all roles for the current user
  async getUserRoles(userId: string, currentUser: boolean = false){
    return await firstValueFrom(this.http.get<any[]>(environment.api.cdn + environment.api.route.getUserRoles + "?userid=" + userId).pipe(
      map((response) => {
        const data = JSON.parse(JSON.stringify(response)).data

        // Set different array depending on if we want the current user roles or the one that he select
        if(currentUser){
          this.currentUserRoles = JSON.parse(JSON.stringify(data));
        }else{
          this.selectedUserRoles = JSON.parse(JSON.stringify(data));
        }
      })
    ));
  }

  // Function that toggle a user role as the user click on it
  toggleUserRole(role: string){
    if(this.userHasRoles(role)){
      this.selectedUserRoles = this.selectedUserRoles.filter(r => r.role !== role);
    }else{
      this.selectedUserRoles.push({"role": role});
    }
  }

  // Function that return if the user have a certain role. currentUser is used to differ when we want the roles of the user that use the manage tool or the user he select
  userHasRoles(role: string | string[], currentUser: boolean = false): boolean{
    const roleToCheck = Array.isArray(role) ? role : [role];
    // Set different array depending on if we want the current user roles or the one that he select
    const targetRoles = currentUser ? this.currentUserRoles : this.selectedUserRoles;

    // Return true if the [roles] that are received are in the user roles
    return targetRoles.some(r => roleToCheck.includes(r.role));
  }

  // Function used to see if a designed serveru is in maint mode
  async isServerInMaintMode(serverLocation: string): Promise<boolean>{
    // Get server info lst all for all the new connections
    const response = await firstValueFrom(this.getServersStatusInfo());
    this.serversInfoList = JSON.parse(JSON.stringify(response.data));

    // Get the proper server that user use
    const server = this.serversInfoList.find(s => s.name === serverLocation);

    // Return value true or false if server is in maint mode or not
    return server ? server.maint_mode === 1 : false;
  }
}
